module.exports = __webpack_public_path__ + "static/TruenoBlk-334f940cf47da59f8cc9e912af427a02.woff2";